import { useComponentEntry } from '@utils/component-framework';
import '@i-ark/models';
import 'react';
import '@tanstack/react-query';
import { selectItemInputEntryById } from '../../../state/selectors/entry.item-input-by-id.js';
import { iArkStore } from '../../../state/store.js';
import { inputCls } from './SimpleInputReadonly.style.js';
import { jsx } from 'react/jsx-runtime';

const SimpleInputReadonly = ({
  pageId,
  item
}) => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const itemEntry = useComponentEntry(entryKey, {
    select: selectItemInputEntryById(pageId, item.id)
  });
  return /*#__PURE__*/jsx("span", {
    className: inputCls,
    children: itemEntry.data?.value
  });
};

export { SimpleInputReadonly };
//# sourceMappingURL=SimpleInputReadonly.js.map
